import { clsx } from 'clsx';
import { ChangeEvent, FC } from 'react';
import { Control } from 'react-hook-form';
import { Select as CommonSelect } from 'atoms/Select';
import { SelectPosition } from 'atoms/Select/types';
import { Select } from 'organisms/Form';
import { ISizeOption } from 'pages/ProductDetail/hooks/types';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './styles.module.css';

interface ISizeSelect {
  control: Control;
  options: ISizeOption[];
  className?: string;
  classes?: { root?: string; select?: string };
}

interface ISizeSelectBare extends Omit<ISizeSelect, 'control'> {
  label?: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
}

export const SizeSelectBare: FC<ISizeSelectBare> = ({
  label,
  options,
  value,
  onChange,
  classes,
}) => {
  const t = useTranslations();

  return (
    <CommonSelect
      name="size"
      options={options}
      label={label || t('product.pdp.size')}
      value={value}
      onChange={onChange}
      classes={{
        root: clsx(styles.rootSelect, styles.select, classes?.root),
        select: clsx(styles.sizeSelect, classes?.select),
      }}
      selectPosition={SelectPosition.LEFT}
    />
  );
};

export const SizeSelect: FC<ISizeSelect> = ({
  control,
  options,
  className,
  classes,
}) => {
  const t = useTranslations();
  return (
    <Select
      control={control}
      name="size"
      label={t('product.pdp.size')}
      options={options}
      classes={{
        root: clsx(styles.rootSelect, classes?.root),
        select: clsx(styles.sizeSelect, classes?.select),
      }}
      className={clsx(styles.select, className)}
    />
  );
};
